import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'
import { inputBase } from '@/components/ui/input'

/*
 * GoodUnited / Textarea. Figma: 10 / Components / Textarea.
 * 12px padding, Roboto / text-base, grows with the content.
 */
function Textarea({ className, rows = 4, ...props }: ComponentProps<'textarea'>) {
    return (
        <textarea
            data-slot='textarea'
            rows={rows}
            className={cn(inputBase, 'field-sizing-content min-h-32 resize-y p-3', className)}
            {...props}
        />
    )
}

export { Textarea }
